import React, { useMemo } from 'react';
import { T } from '@colonist/ui';
import { getSeasonTiming, getSeasonTimingText } from './utils.ts';
import styles from './ProgressDate.module.scss';
import clsx from 'clsx';
export const ProgressDate = ({ className, seasonTimeRemaining })=>{
    const seasonTimingText = useMemo(()=>{
        if (seasonTimeRemaining == undefined) return '???';
        const seasonTiming = getSeasonTiming(seasonTimeRemaining);
        return getSeasonTimingText(seasonTiming);
    }, [
        seasonTimeRemaining
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.progressDateContainer, className)
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:leaderboardPage.seasonEndsIn"
    }), " ", /*#__PURE__*/ React.createElement("b", null, seasonTimingText));
};
